import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { twMerge } from 'tailwind-merge';
export interface FieldLabelProps {
  wrapperAs?: React.ElementType;
  labelRightElement?: React.ReactNode;
  wrapperProps?: Record<string, unknown>;
  label?: React.ReactNode;
  required?: boolean;
  labelClassName?: string;
}
export function FieldLabel(t0) {
  const $ = _c(9);
  const {
    wrapperAs: t1,
    wrapperProps: t2,
    label,
    required,
    labelClassName,
    labelRightElement
  } = t0;
  const WrapperAs = t1 === undefined ? "div" : t1;
  let t3;
  if ($[0] !== t2) {
    t3 = t2 === undefined ? {
      className: "flex justify-between gap-2"
    } : t2;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const wrapperProps = t3;
  let t4;
  if ($[2] !== WrapperAs || $[3] !== label || $[4] !== labelClassName || $[5] !== labelRightElement || $[6] !== required || $[7] !== wrapperProps) {
    t4 = label || required || labelRightElement ? <WrapperAs {...wrapperProps}>{(label || required) && <span className={twMerge("text-text-secondary flex text-base font-medium", labelClassName)}>{label} {required && <span className="text-text-error">*</span>}</span>}{labelRightElement}</WrapperAs> : null;
    $[2] = WrapperAs;
    $[3] = label;
    $[4] = labelClassName;
    $[5] = labelRightElement;
    $[6] = required;
    $[7] = wrapperProps;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}